import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MainSmsAccountFormDto, type MainSmsAccountFormInterface } from '@zaoblako/shared/modules/integration/dtos/main-sms/main-sms-account-form.dto';
import { MainSmsIntegrationTypeEnum } from '@zaoblako/shared/modules/integration/enums/main.sms.integration.type.enum';
import { BaseFormComponent } from '@zaoblako/web/shared/dumbs/base-form/base-form.component';
import { InputTextComponent } from '@zaoblako/web/shared/dumbs/input-text/input-text.component';
import { JoinPipe } from '@zaoblako/web/shared/pipes/join.pipe';
import { ButtonModule } from 'primeng/button';
import { ChipsModule } from 'primeng/chips';
import { SelectButtonModule } from 'primeng/selectbutton';

@Component({
  selector: 'crm-newsletter-sms-form',
  standalone: true,
  imports: [CommonModule, InputTextComponent, JoinPipe, ButtonModule, ChipsModule, FormsModule, SelectButtonModule],
  templateUrl: './newsletter-sms-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewsletterSmsFormComponent extends BaseFormComponent<MainSmsAccountFormInterface> {
  @Input() public sms = <MainSmsAccountFormInterface>{};
  public dto = MainSmsAccountFormDto;

  public engine: 'class-transformer' | 'serde' = 'serde';

  public mainSmsOptions: { label: string; value: MainSmsIntegrationTypeEnum }[] = [
    { label: 'SMS', value: MainSmsIntegrationTypeEnum.SMS },
    { label: 'Почта', value: MainSmsIntegrationTypeEnum.EMAIL }
  ];

  public get MainSmsIntegrationTypeEnum() {
    return MainSmsIntegrationTypeEnum;
  }

  public changeType() {
    if (this.sms.type === MainSmsIntegrationTypeEnum.SMS) {
      this.sms.emails = [];
      this.sms.mailingApiKey = '';
    } else {
      this.sms.sender = '';
      this.sms.project = '';
      this.sms.apiKey = '';
    }
  }

  test($event: any) {
    console.log($event);
  }
}
